import React from 'react';
import PropTypes from 'prop-types';

import { InlineLoader, withTranslation } from '../../common';

function CollectionSearchResultsInlineLoader({ visible, translate }) {
  if (!visible) {
    return null;
  }

  const text = translate('common.loadmore');
  return (
    <InlineLoader
      wrapperClassName="CollectionSearchResultsInlineLoader"
      className="CollectionSearchResultsInlineLoader__Loader"
      text={text}
    />
  );
}

CollectionSearchResultsInlineLoader.propTypes = {
  visible: PropTypes.bool,
  translate: PropTypes.func.isRequired
};

export default withTranslation(CollectionSearchResultsInlineLoader);
